import { useCallback } from "react";
import { useAxiosInstances } from "../../axios-instance";
import { IListaCEP } from "../../../application/models";

export const useListaCEPApi = () => {
  const { axiosAuthInstance } = useAxiosInstances();

  const createListaCEPApi = useCallback(
    async (data: { nome: string; idUsuario: number }): Promise<IListaCEP> => {
      try {
        const result = await axiosAuthInstance.post("/geo-veles/lista-cep/", {
          idUsuario: data.idUsuario,
          nome: data.nome,
        });

        return result.data.listaCEP;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const findListaCEPByIdApi = useCallback(
    async (data: { idVelesGeoListaCEP: number }): Promise<IListaCEP> => {
      try {

        const result = await axiosAuthInstance.get(
          `/geo-veles/lista-cep/${data.idVelesGeoListaCEP}`
        );

        return result.data.listaCEP;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const findListasCEPApi = useCallback(
    async (data: { idUsuario: number }): Promise<IListaCEP[]> => {
      try {
        const result = await axiosAuthInstance.get(
          `/geo-veles/lista-cep/idusuario/${data.idUsuario}`
        )
         return result.data.listaCEP;

      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const updateListaCEPApi = useCallback(
    async (data: {
      idVelesGeoListaCEP: number;
      ceps: string[];
      nome: string;
    }): Promise<IListaCEP> => {
      try {
        const result = await axiosAuthInstance.put(
          "/geo-veles/lista-cep/ceps",
          {
            idVelesGeoListaCEP: data.idVelesGeoListaCEP,
            ceps: data.ceps,
            nome: data.nome,
          }
        );

        return result.data.listaCEP;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  const updateListaCEPStatusApi = useCallback(
    async (data: {
      idVelesGeoListaCEP: number;
      status: boolean;
    }): Promise<IListaCEP> => {
      try {
        const result = await axiosAuthInstance.put(
          "/geo-veles/lista-cep/status",
          {
            idVelesGeoListaCEP: data.idVelesGeoListaCEP,
            status: data.status,
          }
        );

        return result.data.listaCEP;
      } catch (error) {
        throw error;
      }
    },
    [axiosAuthInstance]
  );

  return {
    createListaCEPApi,
    findListaCEPByIdApi,
    findListasCEPApi,
    updateListaCEPApi,
    updateListaCEPStatusApi,
  };
};
